import React from 'react';

export interface ChecklistProgressProps {
  reviewed: number;
  total: number;
}

export const ChecklistProgress: React.FC<ChecklistProgressProps> = ({ reviewed, total }) => {
  const percentage = total > 0 ? Math.round((reviewed / total) * 100) : 0;

  return (
    <div className="flex flex-col gap-[12px]">
      <div className="flex items-center justify-between">
        <span className="text-[20px] leading-[28px] font-bold text-text-secondary">Progress</span>
        <span className="text-base font-bold text-text-secondary">
          {reviewed}/{total} reviewed
        </span>
      </div>
      <div
        role="progressbar"
        aria-valuenow={percentage}
        aria-valuemin={0}
        aria-valuemax={100}
        className="h-[4px] w-full overflow-hidden rounded-full bg-[var(--loader-default-container)]"
      >
        <div
          className="h-full rounded-full bg-[var(--loader-default-fill)] transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};
